import { sideBarData } from "helpers/constant";
import { request } from "service";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import { updateShowRoom } from "redux/action/showrooms";
import endpoints from "service/endpoints";
import classes from "./styles.module.scss";
import { dashBoardIcons, icons } from "helpers/images";
import { history } from "helpers";
import { storeScroll } from "redux/action/login";

const Sidebar = ({ handleCollapse }) => {
  const [isCollapse, setIsCollapse] = useState(false)
  const [filteredSideBar, setFilteredSideBar] = useState([])
  const location = useLocation()
  const storeSidebar = useSelector((state) => state?.login?.sideBarScroll)
  const sidebarRef = useRef(null)
  const fetchShowRoomList =
    location.pathname.includes("workflow") ||
    location.pathname.includes("customer-management")

  const handlltoscroll = (label) => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
  const permittedSections = useSelector(
    (state) => state.login?.permittedSections
  )
  const [activeDropdown, setActiveDropdown] = useState("")
  const [
    isActiveDropdownReferralManagement,
    setActiveDropdownReferralManagement,
  ] = useState(false)

  const [subMenu, setSubMenu] = useState(false)
  const [key, setKey] = useState(0)

  useEffect(() => {
    if (location.pathname.includes("/referral-Management")) {
      setActiveDropdown("ReferralManagement")
    }
    if (activeDropdown === "ReferralManagement") {
      setActiveDropdownReferralManagement(true)
    }
  }, [])

  useEffect(() => {
    if (activeDropdown === "ReferralManagement") {
      setActiveDropdownReferralManagement(true)
    }
  }, [activeDropdown]) // Add activeDropdown to the dependency array

  const DropdownToggle = (item) => {
    setActiveDropdown((prevActiveDropdown) =>
      prevActiveDropdown === item ? "" : item
    )
    if (item === "ReferralManagement") {
      setActiveDropdownReferralManagement((prev) => !prev)
    }
    // Increment the key to trigger a re-render
    setKey((prevKey) => prevKey + 1)
  }

  useEffect(() => {
    if (permittedSections?.length) {
      let filteredSideBar = sideBarData?.filter((section1) =>
        permittedSections?.some(
          (section2) =>
            section1?.name?.toLowerCase() === section2?.name?.toLowerCase()
        )
      )

      let settingsSidebar = sideBarData.filter(
        (section) => section?.name?.toLowerCase() === "settings"
      )

      filteredSideBar = filteredSideBar.includes(settingsSidebar)
        ? filteredSideBar
        : [...filteredSideBar, ...settingsSidebar]

      setFilteredSideBar(filteredSideBar)
    }
  }, [permittedSections])

  const filteredSections =
    permittedSections?.length !== 0 ? filteredSideBar : sideBarData

  const dispatch = useDispatch()
  useEffect(() => {
    if (
      filteredSideBar?.length &&
      !filteredSideBar.some((item) =>
        location.pathname?.includes(item?.linkName)
      )
    )
      history.push(filteredSideBar?.[0]?.to)
  }, [filteredSideBar, location.pathname])

  useEffect(() => {
    if (!fetchShowRoomList) {
      return
    }
    let params = {
      limit: "1000",
      page: 1,
    }
    request({
      url: `${endpoints.customerModule.showroomList}`,
      params,
      baseUrl: "notifications",
    }).then((response) => {
      const temp = response?.data?.data?.showroomList.map((value) => {
        return {
          ...value,
          label: value.city,
          value: value._id,
        }
      })
      dispatch(updateShowRoom(temp))
    })
  }, [fetchShowRoomList])
  const handleSubMenu = (item) => {
    DropdownToggle(item)
    // setSubMenu(!subMenu);
  }

  const handleSidebar = () => {
    handleCollapse(!isCollapse)
    setIsCollapse(!isCollapse)
  }

  const handleLink = (menu) => {
    if (sidebarRef.current) {
      dispatch(storeScroll(sidebarRef.current.scrollTop))
    }
    if (menu === "ReferralManagement") {
      setActiveDropdownReferralManagement(true)
    }
  }

  const handleScrollRestore = () => {
    if (sidebarRef.current) {
      sidebarRef.current.scrollTop = storeSidebar
    }
  }

  useEffect(() => {
    setTimeout(() => {
      handleScrollRestore()
    }, 0)
  }, [storeSidebar])

  return (
    <div
      ref={sidebarRef}
      className={`  ${classes.container} ${isCollapse ? `col-1 ${classes.Sidebaer_Width} ` : "col-2"
        } `}
    >
      <div
        role="button"
        className={`${classes.collapseBlock}`}
        onClick={() => handleSidebar()}
      >
        <img src={dashBoardIcons?.hamburgerIcon} width={20} height={20} />
      </div>
      {filteredSections?.map((menu, index) => {
        const allowedNames = new Set(permittedSections.map(item => item.name));
        const filteredSubOptions = menu?.subOptions?.filter(option => allowedNames.has(option.name));

        return (
          <NavLink
            key={index}
            to={menu.to}
            className={`${classes.navLink} fs-14 fw-500`}
            onClick={() => handleLink(menu.name)}
          >
            <div
              className={`${location.pathname.includes(menu.linkName)
                ? classes.active
                : classes.navItem
                } ${activeDropdown === menu.name ? classes.active : classes.navItem
                } mb-0 my-3`}
              title={isCollapse ? menu.label : ""}
              onClick={(e) => {
                if (menu.name === "ReferralManagement" && !isCollapse) {
                  e.stopPropagation()
                  e.preventDefault()
                  handleSubMenu(menu.name)
                }
              }}
            >
              <img
                src={
                  !location.pathname.includes(menu.linkName)
                    ? menu.image
                    : menu.imageHighlight
                }
                alt={menu.label}
                className={isCollapse ? "pe-0" : "pe-3"}
              />
              {!isCollapse && menu.name !== "ReferralManagement" && (
                <span>{menu.label}</span>
              )}
              {menu.name === "ReferralManagement" && !isCollapse && (
                <>
                  <span
                    onClick={(e) => {
                      e.stopPropagation()
                      e.preventDefault()
                      handleSubMenu(menu.name)
                    }}
                  >
                    {menu.label}
                    {"    "}
                    <img
                      src={
                        activeDropdown !== menu.name
                          ? icons.downArrow
                          : icons.upArrow
                      }
                      className="ml-2"
                    />
                  </span>
                </>
              )}
            </div>
            {isActiveDropdownReferralManagement && (
              <ul className="list-unstyled">
                {filteredSubOptions?.length > 0 &&
                  filteredSubOptions.map((submenu, subIndex) => (
                    <li
                      key={subIndex}
                      className="text-center submenutxt my-2 w-100"
                      onClick={() => handlltoscroll(menu.label)}
                    >
                      <NavLink
                        to={submenu.subLink}
                        className={
                          location.pathname.includes(submenu.subLink)
                            ? `${classes.activeSubLink} ${classes.subMenuLink} w-100`
                            : `${classes.inActiveSubLink} ${classes.subMenuLink} w-100`
                        }
                        onClick={() => handlltoscroll(menu.label)}
                      >
                        {submenu.label}
                      </NavLink>
                    </li>
                  ))}
              </ul>
            )}
          </NavLink>
        )
      })}
    </div>
  )
};

export default Sidebar;
